<mat-select [(value)]="selectedColor" (selectionChange)="selected()">
    <mat-select-trigger>
        {{ 'COLORS.' + getSelectedColorLabel(selectedColor) | translate }}
        <div [style.background-color]="selectedColor" class="dot"></div>
    </mat-select-trigger>
    <mat-option *ngFor="let option of colorOptions" [value]="option.value">
        {{ 'COLORS.' + option.label | translate }}
        <div [style.background-color]="option.value" class="dot"></div>
    </mat-option>
</mat-select>